module.exports = __webpack_public_path__ + "static/media/ic_link_twitter.94adfb4f.svg";